import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { map } from 'rxjs';
import { defaultGalleryIncludes } from './consts';
import { PICFLOW_CONFIG } from './picflow-config';
import { ObservableDataLoaderService } from './services/observable-data-loader.service';

@Injectable({
  providedIn: 'root',
})
export class SharedWithMeGalleryService {
  private observableLoader = inject(ObservableDataLoaderService);
  private config = inject(PICFLOW_CONFIG);
  private http = inject(HttpClient);

  public getSharedWithMeGalleriesRaw() {
    return this.observableLoader.get(`/galleries?shared`, () => {
      const url = `${this.config.apiEndpoint}/galleries/shared?${defaultGalleryIncludes}`;
      return this.http.get<{ data: GalleryDto[] }>(url).pipe(map(resp => resp.data));
    });
  }
}
